import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=4dd70d36&scoped=true&"
import script from "./InfoMessage.vue?vue&type=script&lang=js&"
export * from "./InfoMessage.vue?vue&type=script&lang=js&"
import style0 from "./InfoMessage.vue?vue&type=style&index=0&id=4dd70d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd70d36",
  null
  
)

export default component.exports